import { TransferIntentSourceAccount } from "../class/transferIntent";
export type TransferTotals = {
  total: number;
  preTax: number;
  roth: number;
  afterTax: number;
};

export default (sourceAccounts: TransferIntentSourceAccount[]): TransferTotals => {
  return sourceAccounts.reduce(
    (totals, account) => {
      const { partialTransfer } = account;

      if (!partialTransfer) {
        return totals;
      }

      const preTax = partialTransfer.preTax ?? 0;
      const roth = partialTransfer.roth ?? 0;
      const afterTax = partialTransfer.afterTax ?? 0;

      totals.preTax += preTax;
      totals.roth += roth;
      totals.afterTax += afterTax;
      totals.total += preTax + roth + afterTax;

      return totals;
    },
    { total: 0, preTax: 0, roth: 0, afterTax: 0 },
  );
};
